export default __webpack_public_path__ + "static/hero-healthcare-7d5d5bf69f803383a62dcb3e1479983a.png";